<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
            <div class="mb-20 d-flex ">
                <el-button type="primary" @click="handleAddValue" class="ml-auto">
                    <span class="color-white">
                        add value
                    </span>
                </el-button>
            </div>
            <el-card class="box-card">
                <el-table :data="allValues" style="width: 100%">
                    
                    <el-table-column label="image" prop="imageURL" width="80" >
                        <template #default="scope">
                            <el-image 
                                style="width: 50px; height: 50px" 
                                :src="$getImage(scope.row.imageURL) || ''" 
                                fit="cover"
                                :zoom-rate="1.2"
                                :preview-src-list="[$getImage(scope.row.imageURL)]"
                                :preview-teleported="true"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label="title En">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').title}}
                        </template>
                    </el-table-column>

                    <el-table-column label="title Ar"  >
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'ar_sa').title}}
                        </template>
                    </el-table-column>
                  
                    
                    <el-table-column label="Operations" width="100">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit value"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditValue(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column>
                    <el-table-column label="status" width="100">
                        <template #default="scope">
                            <el-popconfirm 
                                title="Are you sure to change this value status?"
                                @confirm="changeValueStatus(scope.row)"
                                @cancel="scope.row.active = !scope.row.active "
                            >
                                <template #reference>
                                    <el-switch
                                        v-model="scope.row.active"
                                        class="mb-2"
                                    />
                                </template>
                            </el-popconfirm>
                            
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
 
</template>
<script>
export default {
    computed:{
        cachedAllValues(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.values?.list || []
        },
    },
    data(){
        return{
            allValues:[],
            isAddValue:false,
           
        }
    },
    mounted(){
        
        if (!this.cachedAllValues.length){
            this.getAllValues();
        }else{
           
            this.allValues = this.cachedAllValues;
        }
    },
    
    methods:{
       
        async getAllValues(){
            
            const response = await this.$store.dispatch('getAllValues');
          
            this.allValues = response.data;
            
            
        },
    
        async changeValueStatus(valueData){
            
            let dataToSend = {
                status: valueData.status,
                id:valueData.id
            }
            const response = await this.$store.dispatch('changeValueStatus',dataToSend);
            if (response.data.status == 1){
                this.getAllValues();
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                })
            }else{
                const currentValue = this.allValues.find(value => value.id == valueData.id )
                currentValue.status = !currentValue.status
            }
            
        },
       
        async handleAddValue(){
            this.$router.push({
                name:'manage-value',
            })
           
        },
        async handleEditValue(value){
            await this.$store.dispatch('storeCurrentValueToView',value)
            this.$router.push({
                name:'manage-value',
                params:{
                    id:value.id
                }
            })
        }
    }
}
</script>